<script setup lang="ts">
import { onMounted } from 'vue';

import MessageAlert from '@/shared/ui/MessageAlert.vue';
import { EP_ZINDEX_BASE } from '@/shared/ui/z-index';

// Remove the inline init mask defined in index.html. By the time App.vue's
// onMounted fires, the router-view has rendered its first route and the
// real chrome is in place.
onMounted(() => {
  document.getElementById('app-init-loading-container')?.remove();
});
</script>

<template>
  <!-- Element Plus popup pool starts at 3000 so ElMessage / ElDialog /
       ElPopover self-increment above every host overlay tier
       (max 2900 tooltip). See shared/ui/z-index.ts for the full map. -->
  <ElConfigProvider :z-index="EP_ZINDEX_BASE">
    <ElScrollbar class="h-screen" view-class="min-h-screen">
      <RouterView />
    </ElScrollbar>
    <MessageAlert />
  </ElConfigProvider>
</template>
